import { CartItem } from "@/app/cartContext";
import { ClientOrderOptions } from "@/api/types/order";
import { OrderForm } from "../use-delivery-form";

export const mapToDeliveryForm = (
  apiData: ClientOrderOptions,
  items: CartItem[],
): {
  initialState: OrderForm;
  options: ClientOrderOptions;
} => {
  // Берем первый элемент каждого массива как значение по умолчанию
  const defaultDeliveryType = apiData.deliveryTypes?.[0];
  const defaultGrouping = apiData.deliveryGrouping?.[0];
  const defaultAddress =
    apiData.addresses && apiData.addresses.length > 0
      ? apiData.addresses[0]
      : {
          street: "",
          isPrivateHouse: false,
        };

  return {
    initialState: {
      deliveryType: defaultDeliveryType,
      deliveryGrouping: defaultGrouping,
      saveAddress: false,
      address: defaultAddress,
      items: items,
    },
    options: apiData,
  };
};
